import React, {useState, useEffect} from 'react'
import { Container } from "reactstrap";
import { Bell, ChevronRight } from 'assets';
import InformasiUmum from './InformasiUmum';
import LainnyaAndPassword from './LainnyaAndPassword';
import BankAndVerified from './BankAndVerified';
import CustomButton from 'components/CustomButton';
import { API_GET_MAMBOO, API_PUT_MAMBOO } from 'services';
import Swal from 'sweetalert2';
import { setCookie } from 'services/cookies';
import { resolvePhotoUrl } from 'utils/photo';
import "./profile.scss"
import useLoginStore from 'hooks/useLoginStore';

// Jenis dokumen yang bisa diunggah di BankAndVerified.js — daftar ini harus
// sejalan dengan kunci `handleButtonClick(...)` di sana. Sebelumnya field
// dikirim satu per satu dan `ktp` serta `bps` terlewat, sehingga dokumen
// pencipta/ahli waris hilang diam-diam saat disimpan.
const DOCUMENT_FIELDS = ["ktp", "npwp", "nib", "akta", "bps", "lainnya"];

const Profile = () => {
  const [isDisabled, setIsDisabled] = useState(false)
  const [getProfile, setGetProfile] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isPayload, setIsPayload] = useState({})
  const {setProfile, profile} = useLoginStore()

  useEffect(() => {
    fetchProfile()
  },[])

  const fetchProfile = async () => {
    setIsLoading(true)
    await API_GET_MAMBOO.dynamic.getProfile().then((data) => {
      setGetProfile(data)
      setIsPayload(data)
      setIsLoading(false)
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    let data = new FormData();
    let payload = {};

    payload["name"] = isPayload.name || "";
    payload["company_name"] = isPayload.company_name || "";
    payload["ip_base_number"] = isPayload.ip_base_number || null;
    payload["ip_name_number"] = isPayload.ip_name_number || null;
    payload["person_responsible"] = isPayload.person_responsible || "";
    payload["title"] = isPayload.title || "";
    payload["email"] = isPayload.email || "";
    payload["address"] = isPayload.address || "";
    payload["phone_number"] = isPayload.phone_number || "";
    payload["no_referal"] = isPayload.no_referal || "";
    payload["bank_data"] = {
      bank: isPayload.bank?.value || isPayload.bank_accounts.bank || "",
      account_name: isPayload.account_name || isPayload.bank_accounts.account_name || "",
      account_number: isPayload.account_number || isPayload.bank_accounts.account_number || ""
    }
    if(isPayload["profile_photo"] instanceof File) {
      data.append("profile_photo", isPayload.profile_photo)
    }

    DOCUMENT_FIELDS.forEach((field) => {
      if (isPayload[field] instanceof File) {
        data.append(field, isPayload[field])
      }
    })

    data.append("payload", JSON.stringify(payload));

    Swal.fire({
      icon: "question",
      title: "Update Profile",
      text: "Apakah anda yakin data anda sudah benar?",
      showCancelButton: true,
      cancelButtonText: "Tidak",
      showConfirmButton: true,
      confirmButtonText: "Ya",
      confirmButtonColor: "#4dbd74",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await API_PUT_MAMBOO.update
          .updateProfile(data)
          .then(async (resp) => {
            if (resp.photo_profile) {
              setCookie("photo_profile", resolvePhotoUrl(resp.photo_profile));
            }
            await API_GET_MAMBOO.dynamic
              .getProfileById(isPayload.user_id)
              .then((resp) => {
                setProfile(resp)
              })
              .catch((err) => console.log(err))
            Swal.fire("Data berhasil diperbarui", "", "success").then((click) => {
              if(click.isConfirmed) {
                window.location.reload()
              }
            });
          })
          .catch((err) => {
            const message = err?.response?.data?.data || "Data gagal diperbarui";
            Swal.fire("Gagal", message, "error");
          });
          
      } else {
        Swal.fire("Data batal diperbarui", "", "info");
      }
    });
  }

  return (
    <>
    {/* {console.log('ispa', isPayload)} */}
    {!isLoading && 
    <Container fluid className='profile-container'>
      <div className='header-container'>
        <div className='profile-header'>
          <h1>Profile</h1>
        </div>
        <div className='icon-wrapper'>
          <Bell />
        </div>
      </div>
      <InformasiUmum getProfile={getProfile} photoProfile isPayload={isPayload} setIsPayload={setIsPayload} />
      <div className='scope-container'>
      <LainnyaAndPassword getProfile={getProfile} informasiLainnya password isPayload={isPayload} setIsPayload={setIsPayload} />
      <BankAndVerified getProfile={getProfile} isPayload={isPayload} setIsPayload={setIsPayload} />
      </div>
      <div className='frame-button-simpan'>
      <CustomButton
        label="Simpan"
        color={isDisabled ? "secondary-btn" : "primary-btn"}
        className="btn-simpan"
        disabled={isDisabled}
        onClick={(e) => handleSubmit(e)}
      />
      </div>
    </Container>
    }
    </>
  )
}

export default Profile